import { useMemo } from 'react';
import { useAuthStore } from '@/core/stores/auth.store';
import type { DocumentPropsTypes } from '@/core/types/documents';

export const useDocument = (docType: string) => {
    const documents = useAuthStore((state) => state.authState.documents);
    const documentConfig = useMemo(() => {
        const found = documents.find((doc: DocumentPropsTypes) => doc.docType === docType);
        return found;
    }, [documents, docType]);

    return {
        documents,         // All documents if needed
        documentConfig,    // Filtered single document based on docType
    };
};
